import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, moduleTypeNames, implementFunction } from "../../../framework/core/mvvm/module_base";
import ClubHallView from "./club_hall_view";
import ClubHallItem from "../component/club_hall_item";
import ModuleManager from "../../../framework/core/module_manager";
import { club_utils } from "../club_utils";
import ClubHallServer from "../../hall/server/club/club_hall_server";
import SceneManager from "../../../manager/scene_manager";
import NotifyServer from "../../hall/server/notify/notify_server";
import ClubPromotion from "../promotion/club_promotion";
import { IUserCurrencyData } from "../../../manager/user_manager";
import FriendModule from "../../hall/module/friend/friend_module";
import MailModule from "../../hall/module/mail/mail";
import Setting from "../../hall/module/setting/setting";
import ClubBank from "../clubbank/clubbank_module";
import ClubList from "../clubList/clubList";
import ClubNotice from "../clubnotice/clubnotice_module";
import { GameManager } from "../../../manager/game_manager";
import { NotifyData } from "../../public/notify_data";
import Utility from "../../../utility/utility";
import AudioManager from "../../../manager/audio_manager";
import AppData from '../../public/const/app_data';
import ClubUserInfo from "../clubUserInfo/club_userInfo";

const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit("ClubHallModule")
export default class ClubHallModule extends ModuleBase<ClubHallView, null> {

    private allLayerMap: Map<number, any> = new Map();

    private allLayerData: any[] = []

    private curLayer: number;


    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.modelType = null;
        this.viewType = ClubHallView;
        this.needViewMask = true
        this.clickAnywhereClose = false;
        this.needDeferShow = true
        this.windowPrefabResPath = "package/club/module/club_hall"
    }

    onLoad() {

        this.eventBind("Event_Notify_Club_Hall_Change", this.on_club_hall_Changed);

        NotifyServer.instance.onReconnected = () => {

            if (this.node && this.node.active) {

                NotifyServer.instance.registGameTag(`club_${club_utils.clubId}`)

                this.reqClubHallList()
            }
        }

    }

    @bindButtonClickEvent("avatar_icon")
    onAvatarIcon() {

        ModuleManager.instance.isNoAccessShowModule("ClubUserInfo", true, function () {
            ModuleManager.instance.showModule(ClubUserInfo)
            console.log(" onAvatarIcon ");
        })

    }


    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(data: IUserCurrencyData) {


        this.view.updateCurrency(data.chipClub, data.chipClubSafebox);


    }

    private on_club_hall_Changed() {

        let self = this;
        if (this.node && this.node.active) {
            this.reqClubHallList();
        }
    }

    private reqClubHallList(callback?: Function) {

        let self = this;
        club_utils.reqClubHallList(club_utils.clubId, this, (allLayer) => {

            if (!self.inLoading && (!self.node || !self.node.active)) {
                return;
            }

            //ClubHallServer.instance.connectServer();

            if (allLayer) {

                self.allLayerMap.clear();

                self.allLayerData = [];

                let findDefault = false;
                for (let index = 0; index < allLayer.length; index++) {
                    let layer = allLayer[index];

                    let gridList: any[] = layer.gridList;
                    //根据seq来排序
                    layer.gridList = gridList.sort((a, b) => {
                        return a.seq - b.seq;
                    })

                    if (layer.status && layer.isDefault) {
                        findDefault = true;
                        self.curLayer = index + 1;
                    }

                    self.allLayerData.push(layer)
                }

                if (!findDefault) {
                    this.curLayer = 1;
                }

                this.view.updateHallLayer(this.allLayerData[this.curLayer - 1]);
            }

            if (callback) {
                callback(allLayer);
            }

        })
    }

    onDeferShow(intentData) {

        if (intentData.userClubId) {

            club_utils.init(intentData)
            NotifyServer.instance.registGameTag(`club_${intentData.userClubId}`)

            if (Utility.isJSON(intentData.desc)) {

                let desc = JSON.parse(intentData.desc);
                this.view.updateLogo(desc.logo);
            }

        }

        let self = this;
        this.reqClubHallList((allLayer) => {

            if (allLayer) {
                self.show();
            } else {
                self.hide();
            }

        });

    }

    public onShow(intentData: any) {
        AppData.showClubHall = true
        let self = this;
        this.getSelfCurrencyData((data) => {
            self.view.updateCurrency(data.chipClub, data.chipClubSafebox);
        }, true, true);

        SceneManager.lastEntranceOpenModuleName = "ClubHallModule";
        ModuleManager.instance.showModule(ClubNotice, {
            showType: "marquee",
            clubInfo: club_utils.clubInfo
        })
        GameManager.getVersionConfigData()
        NotifyData.instance.changePlayerPos('club', true)

        AudioManager.instance.playClubBgMusic();

        ClubHallServer.instance.connectServer();
        this.view.updateHallLayer(this.allLayerData[this.curLayer - 1]);
        this.eventBind("Event_Notify_Club_Transfer", function (content) {
            self.view.transferRed.active = content
            club_utils.clubInfo.haveTransfer = content
        })
        this.get_bank_red()
    }

    private get_bank_red() {
        let self = this
        let requestData = {
            baseUrl: "club/user/getClubRedPoint?",
            params: {
                userClubId: club_utils.clubInfo.userClubId
            }
        }
        this.apiHttpGet(requestData, function (retData) {
            club_utils.clubInfo.haveTransfer = retData.data.bank
            self.view.transferRed.active = retData.data.bank
        }, (retData) => {

        })
    }
    @bindButtonClickEvent("transfer")
    onTransfer() {

        console.log("transfer");

    }
    @bindButtonClickEvent("notice")
    onNotice() {


        ModuleManager.instance.isNoAccessShowModule("ClubNotice", true, function () {
            ModuleManager.instance.showModule(ClubNotice, {
                showType: "center",
                clubInfo: club_utils.clubInfo
            })
        })

    }


    @bindButtonClickEvent("return")
    onReturn() {
        //this.hide();

        let self = this;
        ModuleManager.instance.showModule(ClubList, true, () => {
            club_utils.clear();
            self.hide();
        });

       
    }

    @bindButtonClickEvent("setting")
    onSetting() {
        ModuleManager.instance.showModule(Setting);
    }

    @bindButtonClickEvent("bank")
    onBank() {
        ModuleManager.instance.isNoAccessShowModule("ClubBank", true, function () {
            ModuleManager.instance.showModule<ClubBank>(ClubBank, club_utils.clubInfo)
        })

    }

    @bindButtonClickEvent("coin")
    onCoin() {
        ModuleManager.instance.isNoAccessShowModule("ClubBank", true, function () {
            ModuleManager.instance.showModule<ClubBank>(ClubBank, club_utils.clubInfo)
        })

    }

    /**
     * 分享
     */
    @bindButtonClickEvent("share")
    onShare() {
        ModuleManager.instance.isNoAccessShowModule("ClubPromotion", true, function () {
            ModuleManager.instance.showModule<ClubPromotion>(ClubPromotion, { clubId: club_utils.clubId, code: club_utils.clubInfo.clubNum })
        })

    }

    /**
     * 好友
     */
    @bindButtonClickEvent("friend")
    onMember() {
        ModuleManager.instance.showModule(FriendModule);
    }

    /**
     * 邮件
     */
    @bindButtonClickEvent("mail")
    onMail() {
        ModuleManager.instance.showModule(MailModule);
    }

    @bindButtonClickEvent("reconnect")
    onReconnect() {

        ClubHallServer.instance.disconnect();

        NotifyServer.instance.disconnect();
    }

    @bindButtonClickEvent("talbeBtn")
    onHallItem(node: cc.Node, customEventData) {

        ModuleManager.instance.isNoAccessShowModule("ClubGame", true, ()=> {
            let tableNode = node.parent.parent;

            let hallItem = tableNode.getComponent(ClubHallItem);

            console.log(" talbeBtn ", hallItem.itemIndex);

            this.view.joinRoom(hallItem);
        })



    }

    onHide() {
        ModuleManager.instance.hideModule("ClubNotice")
        ClubHallServer.instance.exit();
    }

    onDestroy() {

        ClubHallServer.instance.exit()
    }



}
